/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ message: NonNullable<unknown> }} Knp_Lookup_Add_Term_Failed_ToastInputs */

const en_knp_lookup_add_term_failed_toast = /** @type {(inputs: Knp_Lookup_Add_Term_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Failed to add term: ${i?.message}`)
};

const fr_knp_lookup_add_term_failed_toast = /** @type {(inputs: Knp_Lookup_Add_Term_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Echec de l'ajout du terme : ${i?.message}`)
};

const de_knp_lookup_add_term_failed_toast = /** @type {(inputs: Knp_Lookup_Add_Term_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Term konnte nicht hinzugefügt werden: ${i?.message}`)
};

const it_knp_lookup_add_term_failed_toast = /** @type {(inputs: Knp_Lookup_Add_Term_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Impossibile aggiungere il termine: ${i?.message}`)
};

const ru_knp_lookup_add_term_failed_toast = /** @type {(inputs: Knp_Lookup_Add_Term_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Не удалось добавить термин: ${i?.message}`)
};

const es_knp_lookup_add_term_failed_toast = /** @type {(inputs: Knp_Lookup_Add_Term_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`No se pudo agregar el término: ${i?.message}`)
};

const zh_cn2_knp_lookup_add_term_failed_toast = /** @type {(inputs: Knp_Lookup_Add_Term_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`添加术语失败：${i?.message}`)
};

const ja_knp_lookup_add_term_failed_toast = /** @type {(inputs: Knp_Lookup_Add_Term_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`用語の追加に失敗しました: ${i?.message}`)
};

const hi_knp_lookup_add_term_failed_toast = /** @type {(inputs: Knp_Lookup_Add_Term_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`टर्म जोड़ने में विफल: ${i?.message}`)
};

const pt_pt2_knp_lookup_add_term_failed_toast = /** @type {(inputs: Knp_Lookup_Add_Term_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Falha ao adicionar o termo: ${i?.message}`)
};

/**
* | output |
* | --- |
* | "Failed to add term: {message}" |
*
* @param {Knp_Lookup_Add_Term_Failed_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_lookup_add_term_failed_toast = /** @type {((inputs: Knp_Lookup_Add_Term_Failed_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Lookup_Add_Term_Failed_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_knp_lookup_add_term_failed_toast(inputs)
	if (locale === "de") return de_knp_lookup_add_term_failed_toast(inputs)
	if (locale === "it") return it_knp_lookup_add_term_failed_toast(inputs)
	if (locale === "ru") return ru_knp_lookup_add_term_failed_toast(inputs)
	if (locale === "es") return es_knp_lookup_add_term_failed_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_knp_lookup_add_term_failed_toast(inputs)
	if (locale === "ja") return ja_knp_lookup_add_term_failed_toast(inputs)
	if (locale === "hi") return hi_knp_lookup_add_term_failed_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_knp_lookup_add_term_failed_toast(inputs)
	return en_knp_lookup_add_term_failed_toast(inputs)
});